import { render, staticRenderFns } from "./PicturePreviewDialog.vue?vue&type=template&id=b23cc408&scoped=true&"
import script from "./PicturePreviewDialog.vue?vue&type=script&lang=js&"
export * from "./PicturePreviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23cc408",
  null
  
)

export default component.exports